import { render, staticRenderFns } from "./DeviceBasicInfo.vue?vue&type=template&id=6d5adb4f&scoped=true&"
import script from "./DeviceBasicInfo.vue?vue&type=script&lang=js&"
export * from "./DeviceBasicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5adb4f",
  null
  
)

export default component.exports